<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.svg" />
    </vue-element-loading>
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">Edit Category </template>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="12">
              <b-row>
                <b-col class="py-3 text-center">
                  <span
                    style="font-size: 20px; font-weight: 500; color: #a7a7a7"
                  >
                    Category Details
                  </span>
                </b-col>
              </b-row>

              <b-row class="justify-content-md-center">
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('name') }">
                    <b-form-group>
                      <label>Name</label>
                      <b-form-input
                        :disabled="Is_Delete"
                        v-model="name"
                        type="text"
                        id="name"
                        placeholder="Name"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('name')"
                      >
                        <span style="color: red">{{
                          validation.firstError("name")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <!-- <b-col cols="12" md="4">
                  <b-form-group>
                    <label>Deletable</label>

                    <b-form-select
                      v-model="Is_Delete"
                      id="Enabled"
                      :options="[true, false]"
                      text-field="name"
                      value-field="value"
                    ></b-form-select>
                  </b-form-group>
                </b-col> -->
                <b-col cols="12" md="4">
                  <label>Icon</label>
                  <b-form-file
                  :disabled="Is_Delete"
                    v-model="Image"
                    @change="uploadPic"
                  ></b-form-file>
                </b-col>
                <b-col cols="12" md="6">
                  <div :class="{ error: validation.hasError('Description') }">
                    <b-form-group>
                      <label>Description</label>
                      <b-form-textarea
                        v-model="Description"
                        type="text"
                        id="description"
                        placeholder="Description"
                      ></b-form-textarea>
                      <template
                        slot="description"
                        v-if="validation.firstError('Description')"
                      >
                        <span style="color: red">{{
                          validation.firstError("Description")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col
                  cols="12"
                  md="12"
                  class="pt-4 text-center"
                  v-if="prevImage && !categoryImage"
                >
                  <b-img
                    :src="baseURL + '/r/' + prevImage"
                    width="250px"
                  ></b-img>
                </b-col>
                <b-col
                  cols="12"
                  md="12"
                  class="pt-4 text-center"
                  v-if="categoryImage"
                >
                  <b-img :src="categoryImage" width="250px"></b-img>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="justify-content-center">
            <div class="px-2 pt-4">
              <b-button
                variant="outline-primary"
                size="sm"
                @click.prevent="validateInput"
              >
                Update Category
              </b-button>
            </div>
          </b-row>

          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      msg: null,
      Is_Delete: false,
      name: null,
      Description: null,
      prevImage: null,
      Image: null,
      categoryImage: null,
      defValue: {},
    };
  },

  validators: {
    name(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(1)
        .maxLength(120);
    },
    Description(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(50)
        .maxLength(512);
    },
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/category/" + this.$route.params.id,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        // params: {
        //   category:this.$route.params.id
        // },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.defValue = response.data.data;
            this.Is_Delete = response.data.data.Is_Delete;
            this.name = response.data.data.Name;
            this.Description = response.data.data.Description;
            this.prevImage = response.data.data.Icon;
          } else {
            this.msg = response.data.msg;
            var vm = this;
            this.$notify({
              group: "appNotification",
              title: vm.msg,
              text: "",
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    validateInput() {
      this.msg = null;
      this.$validate().then((success) => {
        if (success) {
          this.editCategory();
        } else {
          this.msg = "Please validate input fields";
          return;
        }
      });
    },
    uploadPic(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size > 5242880) {
        this.msg = "File Should be less than 5MB";
        this.showsnackbar = true;
        return;
      }
      this.Image = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.categoryImage = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },
    editCategory() {
      if (
        this.defValue.Name == this.name &&
        this.defValue.Description == this.Description
      ) {
        if (this.Image) {
          this.updateImage();
          return;
        } else {
          this.$notify({
            group: "appNotification",
            title: "Category Details Didn't Changed",
            text: "",
            type: "error",
          });
          this.$router.push("/Categories");
          return;
        }
      }
      this.appLoading = true;
      var banner = {};
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("description", this.Description);
      formData.append("is_delete", this.Is_Delete);
      formData.append("id", this.$route.params.id);
      axios({
        method: "PUT",
        url: "/category",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: formData,
      })
        .then((response) => {
          this.appLoading = false;

          if (response.data.status) {
            if (this.Image) {
              this.updateImage();
            } else {
              this.$notify({
                group: "appNotification",
                title: "Category Updated Successfully",
                text: "",
                type: "success",
              });
              this.$router.push("/Categories");
            }
          } else {
            this.msg = response.data.msg;
            var vm = this;
            this.$notify({
              group: "appNotification",
              title: vm.msg,
              text: "",
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.appLoading = false;
          // this.ServerError = true;
        });
    },
    updateImage() {
      this.appLoading = true;
      var banner = {};
      let formData = new FormData();
      formData.append("image", this.Image);
      formData.append("id", this.$route.params.id);
      axios({
        method: "PUT",
        url: "/category/icon",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: formData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$notify({
              group: "appNotification",
              title: "Category Updated Successfully",
              text: "",
              type: "success",
            });
            this.$router.push("/Categories");
          } else {
            this.msg = response.data.msg;
            var vm = this;
            this.$notify({
              group: "appNotification",
              title: vm.msg,
              text: "",
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
  },
};
</script>
